import { call, put, takeLatest, select } from 'redux-saga/effects';
import { createAndEditTrendCommentAction, deleteTrendCommentAction, getTrendCommentsAction, getTrendCommentsRequest } from './actions';
import { TimeSeriesApi } from 'api/index';
import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';
import { getDateSelection, getSelectedAsset, getSelectedTrendKPIs } from './selectors';

function* fetchTrendCommentsList({ from, to }) {
    yield put(getTrendCommentsAction(apiCallStatus.LOADING));
    try {
        const selectedAsset = yield select(state => getSelectedAsset(state));
        const selectedTrendKPIs = yield select(state => getSelectedTrendKPIs(state));
        const dateSelection = yield select(state => getDateSelection(state));

        const payload = {
            assetId: selectedAsset?.id,
            timeseriesKeys: selectedTrendKPIs,
        };
        const trendCommentsData = yield call(TimeSeriesApi.getCommentsList, payload, from ?? dateSelection.from, to ?? dateSelection.to);
        yield put(getTrendCommentsAction(apiCallStatus.SUCCESS, trendCommentsData?.trendComments ?? []));
    } catch (err) {
        yield put(getTrendCommentsAction(apiCallStatus.ERROR, [], err));
    }
}

function* createAndEditTrendComment({ payload }) {
    yield put(createAndEditTrendCommentAction(apiCallStatus.LOADING));
    try {
        yield call(TimeSeriesApi.createandEditComment, payload);
        yield put(createAndEditTrendCommentAction(apiCallStatus.SUCCESS));
        yield put(getTrendCommentsRequest());
    } catch (err) {
        yield put({
            ...createAndEditTrendCommentAction(apiCallStatus.ERROR, [], err),
            suppressGlobalNotification: true
        });
    }
}

function* deleteTrendComment({ commentId, callbackFn }) {
    yield put(deleteTrendCommentAction(apiCallStatus.LOADING));
    try {
        yield call(TimeSeriesApi.deleteComment, commentId);
        yield put(deleteTrendCommentAction(apiCallStatus.SUCCESS));
        if (callbackFn) {
            callbackFn();
        }
        yield put(getTrendCommentsRequest());
    } catch (err) {
        yield put({
            ...deleteTrendCommentAction(apiCallStatus.ERROR, [], err),
            suppressGlobalNotification: true
        });
    }
}

export function* TrendCommentsWatchers() {
    yield takeLatest(actionTypes.GET_TREND_COMMENTS_LIST_REQUEST, fetchTrendCommentsList);
    yield takeLatest(actionTypes.CREATE_AND_EDIT_TREND_COMMENT_REQUEST, createAndEditTrendComment);
    yield takeLatest(actionTypes.DELETE_TREND_COMMENT_REQUEST, deleteTrendComment);
}
